import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '@appconfig';
import { Observable, of } from 'rxjs';
import { translateDataSourceResultGroups, DataSourceRequestState, SortDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { HttpRepo } from '@shared/services/httprepo';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';
import { CommonMethods } from '@services/common.method';


@Injectable({
  providedIn: 'root'
})
export class WorkOrderService {

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private auth: AuthService,
    private httpRepo: HttpRepo,
    private commonMethod: CommonMethods
  ) {
    this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(), ApiEndPointType.FS);
  }

  public fetchWorkTicketItems(input: any, state: DataSourceRequestState, sort: SortDescriptor[]): Observable<DataResult> {
    const hasGroups = state.group && state.group.length;
    return of({ data: input.Data, total: input.Count }) // Send the state to the server
      .map(({ data, total }: GridDataResult) => // Process the response
        (<GridDataResult>{
          data: hasGroups ? translateDataSourceResultGroups(data) : data,
          total: total,
        })
      )
  }
  // GET List
  GetWorkOrderList(state: DataSourceRequestState, searchKey: string) {
    return this.httpRepo.Get("worktickets", this.httpRepo.GetCommonURLQueryParams(state, searchKey) + "&searchEntity=workticket");
}
  GetWorkOrderReviewList(state: DataSourceRequestState, searchKey: string) {
    return this.httpRepo.Get("WorkTicketReviews", this.httpRepo.GetCommonURLQueryParams(state, searchKey) + "&searchEntity=workticketreview");
   }
  // GET Work Order
  GetWorkOrder(data: any) {
    return this.httpRepo.Get("customers/" + data.customerId + "/jobsites/" + data.jobsiteId + "/worktickets/" + data.ID + "?references=*");
  }
  getDiscounts() {
    return this.httpRepo.Get("discounts");
  }
  // PUT
  public EditWorkOrder(data: any): Observable<any> {
    
        data.WorkTicketPriceBookItems.forEach(pbi=>{
             pbi.ID = CommonMethods.GetID(pbi.ID);
        });
        if(data.AssignedTechnicians.length>0){
            data.AssignedTechnicians[0].ID = CommonMethods.GetID(data.AssignedTechnicians[0].ID);
        }    
        return this.httpRepo.Put("customers/" + data.Customer.ID + "/jobsites/" + data.JobSite.ID + "/worktickets/" + data.ID, data);
  }
  // POST
  public SaveWorkOrder(data: any): Observable<any> {
    data.ID = CommonMethods.GetID('');
    return this.httpRepo.Post("customers/" + data.Customer.ID + "/jobsites/" + data.JobSite.ID + "/worktickets", data);
  }

  GetPriceBookItems(state: DataSourceRequestState, searchKey, jobsiteId: string, overrideItemIds: string[] = []) {
    const url = (jobsiteId)? "pricebook/"+jobsiteId : "pricebook";
    let queryParams = this.httpRepo.GetCommonURLQueryParams(state, searchKey);
    overrideItemIds.forEach((x, i) => {
      queryParams += "&overrideItemIds["+i+"]="+x;
    });
    return this.httpRepo.Get(url, queryParams);
  }
  
  GetPricingForItems(state: DataSourceRequestState, searchKey, jobsiteId: string, priceBookItemIDs: string[], overrideItemIds: string[] = []) {
    const url = (jobsiteId)? "pricebook/prices/"+jobsiteId : "pricebook/prices";
    let queryParams = this.httpRepo.GetCommonURLQueryParams(state, searchKey);
    priceBookItemIDs.forEach((x, i) => {
      queryParams += "&priceBookItemIDs["+i+"]="+x;
    });
    overrideItemIds.forEach((x, i) => {
      queryParams += "&overrideItemIds["+i+"]="+x;
    });
    return this.httpRepo.Get(url, queryParams);
  }

  ChangeStatus(data) {
    return this.httpRepo.Patch("customers/" + data.Customer.ID + "/jobsites/" + data.JobSite.ID + "/worktickets/" + data.ID, data);
  }
  getTaxGroup(taxGroupId) {
    //return this.httpRepo.Get("taxgroups/" + taxGroupId + "?references=*");
    return this.httpRepo.Get("taxgroups/" + taxGroupId + "/taxcodes");
  }
  GetAttachmentURL(CustomerID: string, JobSiteID,WorkTicketID) {
    return this.httpRepo.AbsoluteURL + "/customers/" + CustomerID + "/jobsites/" + JobSiteID + "/worktickets/"+WorkTicketID+"/workticketsattachment";
  }

  Print(workticketId, printType) {
      return this.httpRepo.GetFile("worktickets/" + workticketId + "/documenttypes?documentType="+printType);
  }
}
